
function History () {
  this.undos = []
  this.redos = []
}

History.prototype.max = 20

History.prototype.add = function (action, undo) {
  var stack
  if (undo === true) {
    stack = this.undos
  } else if (undo === false) {
    stack = this.redos
  } else {
    stack = this.undos
  }
  if (stack.length >= this.max) {
    stack.shift()
  }
  return stack.push(action)
}

/*
 * Pops the last recorded undo.
 * Used to remove an undo if there was an error
 */
History.prototype.pop = function () {
  this.undos.pop()
}

History.prototype.undo = function () {
  var action = this.undos.pop()
  if (action) {
    return action.do(true)
  } else {
    return false
  }
}

History.prototype.redo = function () {
  var action = this.redos.pop()
  if (action) {
    return action.do(false)
  } else {
    return false
  }
}

History.prototype.clear = function () {
  this.redos = []
  this.undos = []
}

class Action {
  constructor (callback, state) {
    this.callback = callback
    this.state = state
  }

  do () {
    return this.callback(this.state, ...arguments)
  }
}

History.Action = Action

export {History, Action}
